import { StatRing } from './StatRing';

// On-time vs. late scan *uploads* (not the aligner go/no-go pace — see
// PaceRing history in git blame for that dropped ring). Computed from counts
// rather than inverting the server's latePct, to avoid rounding drift.
// Ported from files-viewer's `patient-files/overview/ScanComplianceRing.tsx`.
//
// This is the "late scans" indicator in the merged Treatment progress card
// (restored in place of PaceRing per product feedback — the pace ring's
// "Stalled" state read as a stale/inactive indicator, which wasn't the
// intent). The ring's percentage and color track the on-time rate
// (higher/greener = fewer late scans); the sublabel spells out the raw
// counts ("X on-time · Y late") so the late count itself is never hidden
// behind the percentage.

function getScanComplianceColor(pct: number): string {
    if (pct >= 90) return '#10b981';
    if (pct >= 70) return '#f59e0b';
    return '#ef4444';
}

function getScanComplianceLabel(pct: number): string {
    if (pct >= 90) return 'On Time';
    if (pct >= 70) return 'Occasional Delays';
    return 'Frequent Delays';
}

interface ScanComplianceRingProps {
    lateCount: number;
    onTimeCount: number;
}

function ScanComplianceRing({ lateCount, onTimeCount }: ScanComplianceRingProps) {
    const total = lateCount + onTimeCount;
    const onTimePct = total > 0 ? Math.round((onTimeCount / total) * 100) : null;

    return (
        <StatRing
            pct={onTimePct}
            color={onTimePct != null ? getScanComplianceColor(onTimePct) : '#9ca3af'}
            label={onTimePct != null ? getScanComplianceLabel(onTimePct) : ''}
            sublabel={total > 0 ? `${onTimeCount} on-time · ${lateCount} late` : 'No scans yet'}
            title={`${onTimeCount} on-time, ${lateCount} late`}
            emptyLabel="Late scans"
        />
    );
}

export { ScanComplianceRing };
